/*
 * Created Date: 28-02-2024, 4:38:35 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Mar 13 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

const basePath = '/my-account'

export const ROUTER_MY_ACCOUNT = {
	profile: `${basePath}/profile`
}

export const TRANSLATE_MY_ACCOUNT = {
	profile: `${basePath}/profile`
}
